<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="80%" @close="close" >
    <el-row>
      <el-table :data="page.records" ref="table"
                :highlight-current-row="true" @current-change="setCurrentRow"
                style="width: 100%" class="athub-inner athub-picker-inner athub-picker-table">
        <el-table-column prop="customerName" label="客户名称">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">客户名称</span><br>
            <el-input v-model="pageSearch.search.lk_customerName" size="mini">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="accountManager" label="负责人">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">责任人</span><br>
            <el-input v-model="pageSearch.search.lk_accountManager" size="mini">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="salesArea" label="商机需求区域">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">商机需求区域</span><br>
            <div style="height: 28px;"></div>
          </template>
        </el-table-column>
        <el-table-column prop="preSalesScaleComments" label="商机规模">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">商机规模</span><br>
            <div style="height: 28px;"></div>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="商机需求时间">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">商机需求时间</span><br>
            <div style="height: 28px;"></div>
          </template>
        </el-table-column>
        <el-table-column prop="comments" label="商机详细描述">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">商机详细描述</span><br>
            <div style="height: 28px;"></div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg athub-inner athub-picker-inner" justify="end">
      <el-pagination @size-change="setPageSearchSize"
                     @current-change="setPageSearchCurrent"
                     :current-page="pageSearch.current"
                     :page-size="10"
                     :page-sizes="[10, 25, 50, 100]"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="page.total">
      </el-pagination>
    </el-row>
    <el-row slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </el-row>
  </el-dialog>
</template>

<script>

import {debounce, merge} from "@/util";
import BusinessOpportunitiesApi from "@/api/billing/business-opportunities-api";

export default {
  name: "business-opportunities-dialog",
  props: {
    title: {
      default: '选择商机'
    },
    search: {},
  },
  data() {
    return {
      text: null,

      dialogVisible: false,
      pageSearch: {
        current: 1,
        size: 10,
        search: {
          lk_customerName: null,
          lk_accountManager: null,
        },
      },
      page: {
        total: 0,
        records: [],
      },

      currentRow: null,
    };
  },
  watch: {
    'search': {
      deep: false,
      immediate: true,
      handler() {
        this.pageSearch.search = merge(true, this.pageSearch.search, this.search);
      }
    },
    'pageSearch.current': {
      deep: false,
      immediate: false,
      handler() {
        this.queryByPage();
      },
    },
    'pageSearch.size': {
      deep: false,
      immediate: false,
      handler() {
        this.reQueryByPage();
      },
    },
    'pageSearch.search': {
      deep: true,
      immediate: false,
      handler() {
        this.reQueryByPage();
      }
    },
  },
  methods: {
    setPageSearchCurrent(current) {
      this.pageSearch.current = current;
    },
    setPageSearchSize(size) {
      this.pageSearch.size = size;
    },
    setPage(page) {
      this.page = page;
    },
    reQueryByPage() {
      if (this.pageSearch.current === 1) {
        this.queryByPage();
      } else {
        this.setPageSearchCurrent(1);
      }
    },
    async doQueryByPage() {
      let page = {total: 0, records: []};
      let pageSearch = JSON.parse(JSON.stringify(this.pageSearch));
      let result = await BusinessOpportunitiesApi.page(pageSearch);
      page.total = result.data.data.total;
      page.records = result.data.data.records;
      if (page.records.length === 0 && this.pageSearch.current > 1) {
        this.setPageSearchCurrent(this.pageSearch.current - 1);
      } else {
        this.setPage(page);
      }
      return page;
    },
    queryByPage: debounce( function() {
      this.doQueryByPage();
    }, 200),
    query() {
      this.reQueryByPage();
    },
    setCurrentRow(currentRow) {
      this.currentRow = currentRow;
    },
    open() {
      this.dialogVisible = true;
      this.pageSearch.search = merge(true, this.pageSearch.search, this.search);
      this.reQueryByPage();
    },
    close() {
      this.dialogVisible = false;
    },
    cancel() {
      this.close();
    },
    confirm() {
      if (this.currentRow == null) {
        this.$message.error('请选择一个商机');
        return;
      }
      this.$emit('confirm', this.currentRow);
      this.close();
    },
  }
}
</script>

<style scoped>

</style>